import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React, { PropsWithChildren } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!;

export const ReCaptchaProvider = ({ children }: PropsWithChildren<{}>) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={RECAPTCHA_SITE_KEY}
    language="en"
    scriptProps={{
      async: true,
      defer: true,
    }}
  >
    {children}
  </GoogleReCaptchaProvider>
);
